import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import { Link as RouterLink } from 'react-router-dom';

import type { ShopSummary } from '../../api/types.ts';
import { ROUTES } from '../../routing/routes.ts';
import { statusChipColor, statusLabel } from './shopsHelpers.ts';

export interface ShopHeaderProps {
  shop: ShopSummary;
}

export function ShopHeader({ shop }: Readonly<ShopHeaderProps>): React.JSX.Element {
  return (
    <Box>
      <Link component={RouterLink} to={ROUTES.shops} variant="body2" sx={{ display: 'inline-block', mb: 1 }}>
        Back to shops
      </Link>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: 1.5,
          flexWrap: 'wrap',
        }}
      >
        <Typography variant="h5">{shop.name}</Typography>
        <Chip label={statusLabel(shop.status)} color={statusChipColor(shop.status)} size="small" />
        {shop.archived_at !== null && <Chip label="Archived" size="small" />}
      </Box>
      <Typography sx={{ fontFamily: 'monospace', opacity: 0.75, mt: 0.5 }}>{shop.shop_code}</Typography>
    </Box>
  );
}

export default ShopHeader;
